import { isUserLoggedIn } from 'src/utils';

type GuestGuardProps = {
  children: React.ReactNode;
};

const GuestGuard = ({ children }: GuestGuardProps) => {
  if (isUserLoggedIn()) {
    window.location.pathname = '/dashboard/send-gift-card';
  }

  return <>{children}</>;
};

export default GuestGuard;
